export const BOT_MODES = {
  NEW: "New",
  EDIT: "Edit",
  DELETE: "Delete",
};
